import React, { useEffect, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'

import { Button } from 'reactstrap';

import "./BetterCarousel.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

export const BetterCarousel = ({ photos, openMenu }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true })

  useEffect(() => {
    if (emblaApi) {
      console.log(emblaApi.slideNodes()) // Access API
    }
  }, [emblaApi])

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        {photos && photos.map(p => (
          <div className="embla__slide d-flex justify-content-center">
            <a onClick={() => openMenu(p.photoId)}>
              {p && !p.finalImage && p.originalImage && <img className="p-4" src={p.originalImage.url} style={{ maxHeight: "35vh" }} />}
              {p && p.finalImage && <img className="p-4" src={p.finalImage.url} style={{ maxHeight: "35vh" }} />}
            </a>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center">
        <Button color="primary" className="btn-circle ms-auto me-2" onClick={scrollPrev}><FontAwesomeIcon icon={faArrowLeft} /></Button>
        <Button color="primary" className="btn-circle ms-2 me-auto" onClick={scrollNext}><FontAwesomeIcon icon={faArrowRight} /></Button>
      </div>
    </div>
  )
}